import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, CardHeader, CardText } from "material-ui/Card";
import Avatar from "material-ui/Avatar";
import { IconVariant } from "../../components/mui/icon";
import ImageVariantByColor from "../../components/image/ImageVariantByColor";
import ImageVariantByAll from "../../components/image/ImageVariantByAll";
import { isEqual } from "../utils";
import lomap from "lodash/map";
import zipObject from "lodash/zipObject";
import { BoxMessage } from "../styled";

class ImagesByVariant extends Component {
  constructor(props) {
    super(props);

    let updateData = {
      "*": {
        photos: []
      }
    };
    this.state = {
      expandedImage: true,
      variant: props.variant,
      photosAll: updateData,
      photoSet: {},
      isByColor: false
    };
  }
  handleExpandChange = expanded => {
    this.setState({ expandedImage: expanded });
  };
  componentWillReceiveProps(nextProps) {
    const { photoSet, photosAll } = this.state;
    if (!isEqual(this.state.variant, nextProps.variant)) {
      const isByColor =
        nextProps.variant.options.filter(item => item.name === "color").length >
        0;
      if (isByColor) {
        const optionsColor = nextProps.variant.options.filter(
          item =>
            item.name === "color" && (item.values && item.values.length > 0)
        );
        if (optionsColor.length > 0) {
          const data = zipObject(
            optionsColor[0].values,
            lomap(optionsColor[0].values, (item, index) => {
              for (const p in photoSet) {
                if (p === item) {
                  return photoSet[p];
                }
              }
              return { code: "#FFFFFF", photos: [] };
            })
          );
          this.setState({
            photoSet: data
          });
          let updateData = {};
          updateData.photo_set = data;
          this.props.onUpdatePhotos(updateData);
        }
      } else {
        this.props.onUpdatePhotos(photosAll);
      }
      this.setState({
        variant: nextProps.variant,
        isByColor
      });
    }
  }
  onUpdatePhotos = () => {
    let data = {};
    data.photo_set = this.state.photoSet;
    this.props.onUpdatePhotos(data);
  };
  onUpdatePhotosAll = () => {
    this.props.onUpdatePhotos(this.state.photosAll);
  };

  renderImageBox() {
    const { photosAll } = this.state;
    const { nameProduct, tagsProduct } = this.props;
    return (
      <div>
        <ImageVariantByAll
          dataImage={photosAll["*"]}
          nameProduct={nameProduct}
          tagsProduct={tagsProduct}
          onUpdatePhotos={this.onUpdatePhotosAll.bind(this)}
          accept="image/*"
        />
      </div>
    );
  }
  renderImageByColorBox() {
    const optionsColor = this.state.variant.options.filter(
      item => item.name === "color" && (item.values && item.values.length > 0)
    );
    const { photoSet } = this.state;
    const { nameProduct, tagsProduct } = this.props;
    if (optionsColor.length > 0) {
      return (
        <div>
          <div>Please upload Product image for each Color</div>
          {optionsColor[0].values.map((item, index) => (
            <div key={item}>
              <ImageVariantByColor
                keyObject={item}
                dataImage={photoSet[item]}
                nameProduct={nameProduct}
                tagsProduct={tagsProduct}
                onUpdatePhotos={this.onUpdatePhotos.bind(this)}
                accept="image/*"
              />
            </div>
          ))}
        </div>
      );
    }
    return null;
  }
  render() {
    const { isByColor } = this.state;
    return (
      <div>
        <Card
          expanded={this.state.expandedImage}
          onExpandChange={this.handleExpandChange}
          style={{ marginBottom: 16 }}
        >
          <CardHeader
            title="Images"
            subtitle={
              <BoxMessage>
                {" "}
                Important: Please complete Variant information first before
                upload product image.
              </BoxMessage>
            }
            avatar={<Avatar icon={<IconVariant />} />}
            actAsExpander={true}
            showExpandableButton={true}
          />
          <CardText expandable={true}>
            <div>
              {isByColor ? this.renderImageByColorBox() : this.renderImageBox()}
            </div>
          </CardText>
        </Card>
      </div>
    );
  }
}

ImagesByVariant.propTypes = {
  variant: PropTypes.object,
  nameProduct: PropTypes.string.isRequired,
  tagsProduct: PropTypes.array,
  onUpdatePhotos: PropTypes.func.isRequired
};

ImagesByVariant.defaultProps = {
  tagsProduct: []
};

export default ImagesByVariant;



// WEBPACK FOOTER //
// ./src/products/createfield/ImagesByVariant.js